var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"input-group"},[_c('label',{staticClass:"label label--small",attrs:{"for":_vm.id}},[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]),_vm._v(" "),_c('ValidationProvider',{attrs:{"rules":_vm.validationRules,"name":_vm.name},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
var touched = ref.touched;
var valid = ref.valid;
var invalid = ref.invalid;
return [_c('input',_vm._b({staticClass:"text-input",class:{
        'is-invalid': touched && invalid,
        'is-valid': touched && valid,
      },attrs:{"type":_vm.type,"id":_vm.id,"name":_vm.name},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},'input',_vm.$attrs,false)),_vm._v(" "),_c('span',{staticClass:"error-message"},[_vm._v(_vm._s(errors[0]))])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-236d9188","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/global/TextInput.vue
// module id = 579
// module chunks = 1